export enum DeltaCalculationMethod {
    AbsoluteDifference = 1,
    PercentChange = 2
}
